import { QueryClient } from '@tanstack/react-query';

/** Shared TanStack Query client (Frontend §State Management: server state). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, staleTime: 15_000, refetchOnWindowFocus: false },
  },
});
